module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAMCAYAAABBV8wuAAAAAXNSR0IArs4c6QAAAKFJREFUGBljZEADu3fv5v/2j0mfGVl827YTfF///dz1n4GBgwkmARL8wfh5J5BvDhIDS2w8coT3O+On7f///7eAKWTav38/z59P37Yz/GewggmCdbz//nsdkGGNLAiW+M/ANIuRkfEPhkSwl8saRkaGaKDEX2RJsOWBHq6rGBmZYpAl4c4N8nRZwcTIEAuTZETWDmKv27YnmoHpvya6OJwPAEeAMnqgKe2XAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./resources/images/pro-arrow_1x.png
// module id = 2317
// module chunks = 0